/*
  导出数据
    data: 数据,
    name: String 导出文件名(默认：'导出数据'),
    suffix: String 导出文件类型(默认：'xlsx')
 */
export const convertRes2Blob = (data, name = '导出数据', suffix = 'xlsx') => {
  const filename = name + '.' + suffix
  let url = window.URL.createObjectURL(new Blob([data]))
  let link = document.createElement("a")
  link.style.display = "none"
  link.href = url
  link.setAttribute("download", filename)
  document.body.appendChild(link)
  link.click()
}

// PDF下载
export const downLoadPDF = (pdfUrl, fileName, suffix) => {
  const url = pdfUrl + '?response-content-type=application/octet-stream' // 支持跨域下载
  const name = fileName + '.' + suffix // 自定义文件名
  const a = document.createElement('a')
  a.href = url
  a.download = name // 下载后文件名
  a.style.display = 'none'
  document.body.appendChild(a)
  a.target = '_blank'
  a.click() // 点击下载
  document.body.removeChild(a) // 下载完成移除元素
}


// 获取文件名
export const getFileNameByUrl = (url) => {
  const filename = url.split('/').pop();
  return filename
}